import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ListaUtilizadoresComponent } from './components/lista-utilizadores/lista-utilizadores.component';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';
import { DashboardUtilizadorDto } from '@app/shared/components/api/models/dashboard.model';

@Component({
  selector: 'app-utilizadores',
  imports: [
    CommonModule,
    BackButtonComponent,
    ListaUtilizadoresComponent
  ],
  providers: [DashboardService],
  templateUrl: './utilizadores.component.html',
  styleUrl: './utilizadores.component.scss',
  standalone: true
})
export class UtilizadoresComponent implements OnInit {
  private readonly dashboardService = inject(DashboardService);
  stats: DashboardUtilizadorDto | null = null;
  loadingStats: boolean = true;

  ngOnInit(): void {
    this.getUtilizadoresStats();
  }

  getUtilizadoresStats(): void {
    this.loadingStats = true;
    this.dashboardService.getDashboardUtilizadores().subscribe({
      next: (res) => {
        this.stats = res?.data || null;
        this.loadingStats = false;
      },
      error: (error) => {
        console.error('Erro ao carregar métricas de utilizadores:', error);
        this.loadingStats = false;
      }
    });
  }
}